import { useRef } from "react";
import styled from "styled-components";
import { FlexColumn } from "../../../../Common/Styles";
import { Posts } from "./Posts";
import { SavedItems } from "./SavedItems";
import { TitleAndButton } from "./TitleAndButton";

export const Studio = () => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <Container $gapInPx={8}>
      <TitleAndButton />
      <FlexColumn $gapInPx={8} ref={ref}>
        <SavedItems />
        <Posts />
      </FlexColumn>
    </Container>
  );
};

const Container = styled(FlexColumn)`
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-s"]};
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  border: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-primary-subtle"].value};
`;
